<template>
  <div class="table">
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i> 角色管理
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="app-container">
        <div style="margin-bottom: 20px">
          <el-input v-model="listQuery.name" placeholder="请输入角色名称" style="width:200px;"  ></el-input>
          <span style = "margin-left:20px;font-size:15px;">状态：</span>
          <el-select v-model="listQuery.role_status" filterable placeholder="请选择">
              <el-option
                v-for="item in statusOptions"
                :key="item.name"
                :label="item.name"
                :value="item.id"
                >
              </el-option>
          </el-select>
          <span style = "margin-left:20px;font-size:15px;">创建时间：</span>
          <el-date-picker
            v-model="listQuery.create_time"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['24:00:00']"
          ></el-date-picker>
          <span style = "margin-left:20px;font-size:15px;">更新时间：</span>
          <el-date-picker
            v-model="listQuery.update_time"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['24:00:00']"
          ></el-date-picker>
        
        <div style="float:right; margin:30px 30px 20px 0;">
          <el-button
            class="filter-item"
            style="margin-left: 10px;"
            type="primary"
            icon="el-icon-search"
            @click="handleFilter"
          >搜索</el-button>
          <el-button
            class="filter-item"
            style="margin-left: 10px;"
            type="success"
            @click="handleCreate"
          >添加</el-button>
          <el-button
            class="filter-item"
            style="margin-left: 10px;"
            type="warning"
            @click="resetAll"
          >重置</el-button>
        </div>
        </div>

        <el-table border v-loading="listLoading"   min-height="200"  max-height="1000" :data="tableData" style="width: 100%;" >
          <el-table-column prop="name" label="角色名称" width="150" />
          <el-table-column prop="role_status_name" label="状态" width="100" />
          <el-table-column prop="created_at" label="创建时间" width="200" />
          <el-table-column prop="updated_at" label="更新时间" width="200" />
          <el-table-column label="操作" fixed="right" class-name="small-padding fixed-width">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-edit"
                @click="handleUpdate(scope.row)"
              >编辑</el-button>
              <el-button size="mini" type="danger"  icon="el-icon-delete"  @click="deleteRole(scope.row)">删除</el-button>
              <el-button
                type="info" 
                size="mini"
                @click="banRole(scope.row)"
                v-if ="scope.row.role_status == 1"
              >禁用</el-button>
              <el-button
                type="success" 
                size="mini"
                @click="banRole(scope.row)"
                 v-if ="scope.row.role_status == 0"
              >恢复</el-button>
            </template>
          </el-table-column>
        </el-table>

        <pagination
          v-show="total>0"
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          @pagination="roleList"
        />

        <el-dialog title="新增角色"  center width="40%" :visible.sync="addShow">
            <el-form :model="formData" style="margin-left:50px;">
                <el-form-item label="角色名称" :label-width="formLabelWidth">
                <el-col :span="8">
                    <el-input v-model="addRoleName"   ></el-input>
                </el-col>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
            <el-button @click="addShow = false">取 消</el-button>
            <el-button type="primary" @click="sureAdd">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog title="删除"  center width="40%" :visible.sync="deleteShow">
            <p>确认删除此角色吗？</p>
            <div slot="footer" class="dialog-footer">
            <el-button @click="deleteShow = false">取 消</el-button>
            <el-button type="primary" @click="sureDelete">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog title="状态管理"  center width="40%" :visible.sync="banShow">
            <p>{{disabText}}</p>
            <div slot="footer" class="dialog-footer">
            <el-button @click="banShow = false">取 消</el-button>
            <el-button type="primary" @click="sureBan">确 定</el-button>
          </div>
        </el-dialog>
        
        <el-dialog title="角色管理"  center width="60%" :visible.sync="dialogFormVisible">
          <el-form :model="formData" style="margin-left:50px;">
            <el-form-item label="角色名称" :label-width="formLabelWidth">
              <el-col :span="8">
                <el-input v-model="formData.name"  ></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="权限" :label-width="formLabelWidth">
              <el-col :span="24">


                 <div class="transfer">
                    <div class="left box">
                        <el-tree
                            ref="tree"
                            node-key="id"
                            :default-expand-all="true"
                            :props="props"
                            :data="formData.role_data_left"
                            show-checkbox
                        ></el-tree>
                    </div>
                    <div class="buttons">
                        <div>
                            <el-button icon="el-icon-arrow-right" @click="toRight" type="primary" circle></el-button>
                        </div>
                        <div>
                            <el-button icon="el-icon-arrow-left" @click="toLeft" type="primary" circle></el-button>
                        </div>
                    </div>
                    <div class="right box">
                        <el-checkbox-group
                            ref="checkGroup"
                            @change="checkBoxGroupChange"
                            v-model="checkList"
                        >
                            <el-checkbox
                                v-for="(item,idx) in formData.role_data_right"
                                :key="idx"
                                :value="item"
                                :checked="item.isChecked"
                                :label="item.node.description"
                            ></el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
              </el-col>
            </el-form-item>
            <el-form-item label="页面字段权限" :label-width="formLabelWidth" v-if="formData.page_user_info && formData.page_user_info.length > 0">
              <el-col :span="24">
                <div class="page-user-info-tip">勾选的字段 value=1，未勾选 value=0，保存时一并提交（用户信息查询页表头由此决定）</div>
                <div class="page-user-info-box">
                  <el-checkbox
                    v-for="item in formData.page_user_info"
                    :key="item.field"
                    :true-label="1"
                    :false-label="0"
                    v-model="item.value"
                  >{{ item.title }}</el-checkbox>
                </div>
              </el-col>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="removeEdit">取 消</el-button>
            <el-button type="primary" @click="handleCreateUpdateStore">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import {
  roleListApi,
  addRoleApi,
  deleteRoleApi,
  setRoleStatusApi,
  getRolePermissionApi,
  getPermissionTreeApi,
  editRoleApi
} from "@/api/new_admin_role.js";
import Pagination from "@/components/pagination/index";

export default {
  components: { Pagination },
  name :"newRole",
  data() {
    return {
      // 列表
      listLoading: false,
      total: 0,
      tableData: [],
      listQuery: {
        name:"",
        role_status:"",
        create_time:[],
        update_time:[],
        page: 1,
        limit: 10
      },
      operation:"",
      disabText:"",
      statusOptions:[
         {
          name:"正常",
          id:"1"
        },
        {
          name:"禁用",
          id:"0"
        },
      ],
      deleteShow:false,
      addShow:false,
      addRoleName:"",
      banShow:false,
      banID:"",

      // 表单
      dialogFormVisible: false,
      idDisabled: true,
      formData: {
        id: "",
        name: "",
        role_data_left: [],
        role_data_right: [],
        permission_ids:[],
        page_user_info: [] // 页面字段权限（用户信息查询页表头由此决定）
      },
      checkList:[],
      props: {
                label: "description",
                children: "children"
            },
      rightCheckeds: [],
      formLabelWidth: "120px",
      formInputWidth: "200px"
    };
  },
  created() {
    this.roleList(this.listQuery);
  },
  methods: {
    roleList() {
      this.listLoading = true;
      roleListApi(this.listQuery)
        .then(response => {
          const data = response.data.data.data;
          for(let item of data){
            if(item.role_status == 0){
                item.role_status_name = "禁用"
            }else if(item.role_status == 1){
                item.role_status_name = "正常"
            }
          }
          this.tableData = data;
          this.total = response.data.data.total;
          setTimeout(() => {
            this.listLoading = false;
          }, 0.5 * 1000);
        })
        .catch(error => {
          this.listLoading = false;
        });
    },
    getPermissionTree(){
      getPermissionTreeApi()
       .then(response =>{
         this.formData.role_data_left = response.data.data;
       })
       .catch(error=>{
       })
    },
    handleResetForm() {
      this.formData.id = "";
      this.formData.name = "";
      this.formData.permission_data_right = [];
      this.formData.page_user_info = [];
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.roleList(this.listQuery);
    },
    handleCreate() {
        this.addRoleName = "",
        this.addShow = true;
    },
    sureAdd(){
        addRoleApi({name:this.addRoleName})
         .then(response=>{
          if(response.data.code == 200){
            this.$message.success(response.data.message);
            this.roleList(this.listQuery);
            this.addShow = false;
          }
          else {
            this.$message.error(response.data.message);
          }
         })
         .catch(error=>{})
    },
    resetAll(){
        this.listQuery.name = "";
        this.listQuery.role_status = "";
        this.listQuery.create_time = "";
        this.listQuery.update_time = "";
        this.listQuery.page = 1;
        this.listQuery.limit = 10;
        this.roleList(this.listQuery);
    },
    removeEdit(){
      this.dialogFormVisible = false;
      let data = [];
      for(let item of this.formData.role_data_right){
         data.push(item.node.id);
      }
      this.formData.permission_ids = data;
    },
    handleCreateUpdateStore() {
      let data =[];
      for(let item of this.formData.role_data_right){
         data.push(item.node.id);
        }
      this.formData.permission_ids = data;
      let array = {
        id:"",
        name:"",
        permission_ids:[],
        page_user_info: []
      }
      array.id  = this.formData.id ;
      array.name  = this.formData.name ;
      array.permission_ids  = this.formData.permission_ids ;
      // 提交时回传全量 page_user_info（含未勾选项，value=0）
      array.page_user_info = this.formData.page_user_info || [];
      editRoleApi(array)
        .then(response => {
          if(response.data.code == 200){
            this.dialogFormVisible = false;
            this.$message.success(response.data.message);
            this.roleList(this.listQuery);
          }
          else {
            this.$message.error(response.data.message);
          }
        })
        .catch(error => {});
    },
    handleUpdate(row) {
      this.checkList = [];
      this.formData.id = row.id ;
      this.formData.name = row.name;
      this.getPermissionTree();
      let data = {
        id:""
      }
      data.id = row.id
      getRolePermissionApi(data)
       .then(response =>{
          // 新返回结构：data: { role_permission: [...], page_user_info: [...] }
          // 兼容老结构：data 直接是数组
          const payload = response.data.data || {};
          const rolePermission = Array.isArray(payload)
            ? payload
            : (payload.role_permission || []);
          const pageUserInfo = Array.isArray(payload) ? [] : (payload.page_user_info || []);

          this.formData.role_data_right = []
          for(let item of rolePermission){
            let a = {
              node:{},
              isChecked:false,
            }
            a.node.id = item.id;
            a.node.description = item.description;
            this.formData.role_data_right.push(a);
          }
          // page_user_info 直接放入 formData，CheckBox 双向绑定 item.value（0/1）
          this.formData.page_user_info = pageUserInfo.map(it => ({
            title: it.title,
            field: it.field,
            value: it.value === 1 ? 1 : 0,
          }));
       })
       .catch(error=>{

       })
      this.dialogFormVisible = true;
      this.formData.name = row.name;
    },
    banRole(item){
      if(item.role_status == 1){
        this.operation = 0;
        this.disabText = "确认禁用此角色权限？"
      }
      else if(item.role_status == 0){
        this.operation = 1;
        this.disabText = "确认恢复此角色权限？"
      }
        this.banId = item.id ; 
        this.banShow = true;
    },
    sureBan(){
      let data = {
        id:"",
        operation:""
      }
      data.id = this.banId;
      data.operation = this.operation;
      setRoleStatusApi(data)
       .then(response=>{
         if(response.data.code == 200){
            this.banShow = false; 
            this.$message.success(response.data.message)
            this.roleList(this.listQuery);
          }
          else {
            this.$message.error(response.data.message);
          }
       })
       .catch(error=>{})
    },
    handleDownload() {
    },
    deleteRole(item){
       this.deleteShow = true;
       this.deleteID = item.id;
    },
    sureDelete(){
      deleteRoleApi({id:this.deleteID })
        .then(response => {
          console.log("code",response)
          if(response.data.code == 200){
              this.$message.success(response.data.message);
              this.roleList(this.listQuery);
          }else{
              this.$message.error(response.data.message);
          }
        })
        .catch(error => {});
        this.deleteShow = false;
    },
    
    // 权限的穿梭框
    getExpandTreeData(tree_data) {
            let arr = [];
            let expandTree = function(data) {
                arr.push(data);
                if (data.children && data.children.length) {
                    data.children.forEach(item => {
                        expandTree(item);
                    });
                }
            };
            tree_data.forEach(item => {
                expandTree(item);
            });
            return arr;
        },
        checkBoxGroupChange() {
            let checkBoxs = this.$refs.checkGroup.$children;
            this.rightCheckeds = [];
            checkBoxs.forEach(item => {
                if (item.isChecked) {
                    this.rightCheckeds.push(item.value);
                }
            });
        },
        toRight() {
            let res = this.$refs.tree.getCheckedNodes(true);
            let arr = [];
            let parent = [];
            let expandNodes = this.getExpandTreeData(this.$refs.tree.data);
            res.forEach(item => {
                let current = {
                    node: item,
                    parent: null,
                    isChecked: false
                };
                // 找到父节点
                expandNodes.forEach(parent => {
                    if (parent.id == item.pid) {
                        current.parent = parent;
                    }
                });
                let copyCheck = 0
                for(let item of this.formData.role_data_right){
                  if(item.node.id == current.node.id && current.parent != null){
                    copyCheck = 1
                  }
                }
                if(current.node.id == 147){
                    copyCheck = 1
                }
                if(copyCheck == 0){
                  this.formData.role_data_right.push(current);
                }
            });
        },
        toLeft() {
            this.rightCheckeds.forEach(checkedNode => {
                this.formData.role_data_right.forEach((item, idx) => {
                    if (item.node.id === checkedNode.node.id) {
                        // 检查parent是否在右边.如果在,则先添加parent节点
                        this.formData.role_data_right.splice(idx, 1);
                        // this.formData.role_data_right.forEach((item2,idx2) => {
                        //     if (item.parent && item2.node.id === item.parent.id) {
                        //         this.$refs.tree.append(
                        //             item2.node,
                        //             (item2.parent && item2.parent.id) ||
                        //                 undefined
                        //         );
                        //         this.formData.role_data_right.splice(idx2, 1);
                        //     }
                        // });
                        // this.$refs.tree.append(
                        //     item.node,
                        //     (item.parent && item.parent.id) || undefined
                        // );
                        this.formData.role_data_right.splice(idx, 1);
                    }
                });
            });
        }
  }
};
</script>
<style>
div.el-transfer .el-transfer-panel {
  width: 400px;
}
</style>
<style lang="less" scoped>
.transfer {
    display: flex;
    flex-direction: row;

    .box {
        width: 250px;
        border: 1px solid #ccc;
        padding: 20px;
        height:500px;
        overflow: auto;
        box-sizing: border-box;
    }

    .buttons {
        margin-top:30%;
        display: flex;
        flex-direction: column;
    }

    .right .el-checkbox-group {
        display: flex;
        flex-direction: column;
    }
}
.page-user-info-tip {
    font-size: 12px;
    color: #8c8c8c;
    margin-bottom: 6px;
}
.page-user-info-box {
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 10px;
    display: flex;
    flex-wrap: wrap;
    gap: 8px 16px;
}
</style>